import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HeroSection } from './components/sections/HeroSection';
import { TrustedBySection } from './components/sections/TrustedBySection';
import { VideoTestimonialsSection } from './components/sections/VideoTestimonialsSection';
import { CoachesSection } from './components/sections/CoachesSection';
import { TechnicalTeamSection } from './components/sections/TechnicalTeamSection';
import { ValueStackSection } from './components/sections/ValueStackSection';
import { TimelineSection } from './components/sections/TimelineSection';
import { CoachingTiersSection } from './components/sections/CoachingTiersSection';
import { AddOnSection } from './components/sections/AddOnSection';
import { TestimonialsSection } from './components/sections/TestimonialsSection';
import { CTASection } from './components/sections/CTASection';
import { FAQSection } from './components/sections/FAQSection';
import { LowerTierSection } from './components/sections/LowerTierSection';
import { OnboardingPage } from './components/pages/OnboardingPage';
import { BookingPage } from './components/pages/BookingPage';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// HomePage component to keep all the existing sections together
const HomePage = () => <div className="w-full min-h-screen bg-gradient-to-b from-[#231232] to-[#1a0d24]" data-id="element-0">
    <HeroSection data-id="element-1" />
    
    <VideoTestimonialsSection data-id="element-2" />
    <CoachesSection data-id="element-3" />
    <TechnicalTeamSection data-id="element-4" />
    <ValueStackSection data-id="element-5" />
    <TimelineSection data-id="element-6" />
    <AddOnSection data-id="element-7" />
    <TestimonialsSection data-id="element-8" />
    <CTASection data-id="element-9" />
    <FAQSection data-id="element-10" />
    <TrustedBySection data-id="element-11" />
  </div>;
export function App() {
  useEffect(() => {
    // Initialize Amplitude after the library loads
    const initializeAmplitude = () => {
      if (typeof window !== 'undefined' && window.amplitude) {
        try {
          window.amplitude.add(window.sessionReplay.plugin({
            sampleRate: 1
          }));
          window.amplitude.init('c6d27b6debb3ed4d9204f7f2b635f009', {
            fetchRemoteConfig: true,
            autocapture: true
          });
        } catch (error) {
          console.warn('Amplitude initialization failed:', error);
        }
      } else {
        // Retry after a short delay if amplitude isn't loaded yet
        setTimeout(initializeAmplitude, 100);
      }
    };
    // Start initialization attempt
    initializeAmplitude();
  }, []);
  return <HelmetProvider data-id="element-12">
      <Helmet data-id="element-13">
        <script src="https://cdn.amplitude.com/script/c6d27b6debb3ed4d9204f7f2b635f009.js" data-id="element-14" />
      </Helmet>
      <Router data-id="element-15">
        <Routes data-id="element-16">
          <Route path="/" element={<HomePage data-id="element-18" />} data-id="element-17" />
          <Route path="/onboarding" element={<OnboardingPage data-id="element-20" />} data-id="element-19" />
          <Route path="/start" element={<BookingPage data-id="element-22" />} data-id="element-21" />
        </Routes>
      </Router>
    </HelmetProvider>;
}